import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ViewPoLineException from '../entities/inbound-exceptions/view-po-line-exceptions';
interface InboundExceptionState extends ListState<ViewPoLineException>{
   
}
class InboundExceptionModule extends ListModule<InboundExceptionState, any, ViewPoLineException>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ViewPoLineException>(),
        loading: false
    }
    actions={
        async getAll(context:ActionContext<InboundExceptionState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InboundException/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<ViewPoLineException>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context: ActionContext<InboundExceptionState, any>, payload: any) {
            await Ajax.post('/api/services/app/InboundException/Create', payload.data);
        },
        
        async checkProductInfo(context:ActionContext<InboundExceptionState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/InboundException/CheckProductInfo', { params: payload.data });
            return reponse.data.result;
        },
        async getExceptionPoId(context:ActionContext<InboundExceptionState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/InboundException/GetExceptionPoId', { params: payload.data });
            return reponse.data.result;
        }
    }
}
const inboundExceptionModule=new InboundExceptionModule();
export default inboundExceptionModule;